@use "src/theme";

.link {
  display: inline-flex;
  align-items: center;
  --color-ring: currentColor;
  transition:
    color 150ms ease,
    filter 150ms ease,
    text-decoration-color 150ms ease;

  @each $name, $var in theme.$color-map {
    &[data-link-color="#{$name}"] {
      color: var(--color-#{$var});

      &:hover {
        filter: brightness(0.82);
      }
    }
  }
}

.hyperlink {
  text-decoration: underline;
  color: var(--color-primary);

  &:hover {
    color: var(--color-action-hover);
  }

  // On a dark band set into a page (a section with its own data-theme="dark"), purple reads
  // poorly: links take the text's colour and keep their underline.
  :global(:not(html)[data-theme="dark"]) & {
    color: var(--color-foreground);
    text-decoration-color: color-mix(in srgb, var(--color-foreground) 45%, transparent);

    &:hover {
      color: var(--color-foreground);
      text-decoration-color: var(--color-foreground);
    }
  }
}

.minimal {
  text-decoration: underline;

  &:hover {
    color: var(--color-action-hover);
  }
}
